import {types} from '../actions/types';

const initialState = {
  loading: false,
  data: {},
  error: {},
};

const requestKYCUpdatationReducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case types.SEND_REQUEST_KYC_UPDATION:
      return {
        ...state,
        loading: true,
      };
    case types.SEND_REQUEST_KYC_UPDATION_SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case types.SEND_REQUEST_KYC_UPDATION_FAILURE:
      return {
        ...state,
        data: {},
        error: payload,
        loading: false,
      };
      case types.CLEAR_REQUEST_KYC_UPDATION:
        return {
          ...state,
          data: {},
          loading: false,
        };
    default:
      return state;
  }
};

export default requestKYCUpdatationReducer;